import { loadable } from 'react-lazily/loadable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { refreshWithUserToken, setNewPassword, signOut } from '../Authentication/authentication';
import { getUserGeolocation } from '../components/geo/getUserGeoLocation';
import { TransactionFunctions, UserFunctions } from '../redux/actions/AppActionFunctions/AppActions';
import { withRouter } from '../router/withRouter';
const { App } = loadable(() => import(/* webpackPreload: true */ '../components/AppMainView'));
const debug = process.env.REACT_APP_DEBUG && false;
const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        init: (cognitoUser, userGroupRoles) => {
            debug && console.log('App Container requested init', ownProps);
        },
        signOut: () => dispatch(signOut()),
        doRefreshWithUserToken: () => dispatch(refreshWithUserToken()),
        getUserGeolocation: () => dispatch(getUserGeolocation()),
        setNewPassword: (user, password) => dispatch(setNewPassword(user, password)),
        userFunctions: bindActionCreators(UserFunctions, dispatch),
        transactionFunctions: bindActionCreators(TransactionFunctions, dispatch),
    };
};
const mapStateToProps = (state) => ({
    thingViewMap: state.AppReducer.thingViewMap,
    controlsMap: state.AppReducer.controlsMap,
    externalTreeDefinitionMap: state.AppReducer.externalTreeDefinitionMap,
    domainTreeMapping: state.AppReducer.domainTreeMapping,
    externalMenuOrdering: state.AppReducer.externalMenuOrdering,
    isAuthenticated: state.AccessReducer.isAuthenticated,
    user: state.AppReducer.user,
    userCustomers: state.AppReducer.userCustomers,
    contextCustomer: state.AppReducer.contextCustomer,
    contextProperty: state.AppReducer.contextProperty,
    contextSecondaryObject: state.AppReducer.contextSecondaryObject,
    pinger: state.AppReducer.pinger,
    userGroupRoles: state.AppReducer.userGroupRoles,
    userSelectedGroup: state.AppReducer.userSelectedGroup,
    useSpecializedViews: state.AppReducer.useSpecializedViews,
    roleArbitrationInstance: state.AppReducer.roleArbitrationInstance,
    cognitoUser: state.AccessReducer.cognitoUser,
    applicationData: state.AppReducer.applicationData,
    didInvalidate: state.AccessReducer.didInvalidate,
    isSmallView: state.AppReducer.isSmallView,
});
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(App));
